import React from 'react';

const IconTemplate = () => {
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 600 600">
      <g>
        <g>
          <rect x="84.9" y="154.2" className="sm-home__template-icon-styling" width="328.3" height="393.9" />
          <line className="sm-home__template-icon-styling" x1="212.9" y1="257.7" x2="337.7" y2="257.7" />
          <line className="sm-home__template-icon-styling" x1="212.9" y1="351.6" x2="337.7" y2="351.6" />
          <circle id="XMLID_24_" className="sm-home__icon-fill" cx="167.8" cy="351.2" r="13.6" />
          <line className="sm-home__template-icon-styling" x1="212.9" y1="445.4" x2="337.7" y2="445.4" />
          <circle id="XMLID_23_" className="sm-home__icon-fill" cx="167.8" cy="445.1" r="13.6" />
          <polyline className="sm-home__template-icon-styling" points="200.5,226.7 156.4,270.9 135,249.6" />
        </g>
        <polyline
          className="sm-home__template-icon-styling"
          points="136.2,154.2 136.2,103.3 464.4,103.3 464.4,497.2 413.2,497.2"
        />
        <polyline
          className="sm-home__template-icon-styling"
          points="186.8,103.3 186.8,51.9 515.1,51.9 515.1,445.8 464.4,445.8"
        />
      </g>
    </svg>
  );
};

export default IconTemplate;
